/* eslint no-param-reassign: 0 */

const demapify = (map) => {
  if (map instanceof Array) {
    const newArr = [];
    map.forEach((x) => {
      newArr.push(demapify(x));
    });

    return newArr;
  }
  if (!(map instanceof Map)) {
    return map;
  }
  const obj = {};
  map.forEach((v, k) => {
    obj[k] = demapify(v);
  });

  return obj;
};

const groupBy = (list, keyGetter) => {
  const map = new Map();
  list.forEach((item) => {
    const key = keyGetter(item);
    if (!map.has(key)) {
      map.set(key, [item]);
    } else {
      map.get(key).push(item);
    }
  });

  return demapify(map);
};

export default groupBy;
